export const adaptProfesionalResumen = (data) => {
    const { profesionalRI, profesionalEspecialidadRI } = data?.profesionalRIById || {};
    return {
        profesionalRI: profesionalRI?.map(x => x.idTipoProfesionalNavigation?.descripcion),
        profesionalEspecialidadRI: profesionalEspecialidadRI?.map(x => x.idEspecialidadNavigation?.descripcion)
    }
}
